export const appRouteConstants = {
    AUTH: {
        LOGIN: 'login',
        RESET: 'reset-password',
        RESET_REQUEST: 'reset-req'
    },
    DASHBOARD: 'employee/dashboard',
    EMPLOYEE_MANAGEMENT: {
        PROFILE: 'employee/employee-management/profile',
        ADDRESS: 'employee/employee-management/address',
        DOCUMENTS: 'employee/employee-management/documents',
        HISTORY: 'employee/employee-management/history',
        ATTENDANCE: 'employee/employee-management/attendance',
        ABSENCES: 'employee/employee-management/absences'
    },
    TIMESHEET: {
        LIST:   'employee/timesheet-management/timesheets',
        SUBMIT: 'employee/timesheet-management/submit',
        DETAIL: 'employee/timesheet-management/detail'
    },
    PAYROLL: {
        PAYSTUBS: 'employee/payroll/paystubs',
        TAX_DOCS: 'employee/payroll/tax-docs'
    },
    HELPDESK: {
        LIST: 'employee/helpdesk/requests',
        NEW: 'employee/helpdesk/new'
    },
    ATTENDANCE: {
        LIST: 'employee/attendance',
        NEW: 'employee/attendance/details/'
    },
    SETTINGS: {
        PAPERLESS: 'employee/settings/paperless'
    },
    ACCURALSUMMARY:{
        EMPYEARSUMMARY: 'employee/accuralSummary/accuralEmpSummary',
        EMPHISTORY:'employee/accuralSummary/accuralEmpHistory'
    }
};
